module.exports = __webpack_public_path__ + "static/media/Cookie.a5e09b24.svg";